import { render, staticRenderFns } from "./TrendsHorizontal.vue?vue&type=template&id=01bd3199&"
import script from "./TrendsHorizontal.vue?vue&type=script&lang=js&"
export * from "./TrendsHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01bd3199')) {
      api.createRecord('01bd3199', component.options)
    } else {
      api.reload('01bd3199', component.options)
    }
    module.hot.accept("./TrendsHorizontal.vue?vue&type=template&id=01bd3199&", function () {
      api.rerender('01bd3199', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/trends/TrendsHorizontal.vue"
export default component.exports